import { Fragment, h } from "preact";
import { TierInfoProps } from "../../../components/tier-info/tier-info";
import { FullFlameIcon } from "../../../icons/FullFlame";

const relativePathToAssets = '';
export const tierList: TierInfoProps[] = [
  {
    tierPoints: {
      title: 'Queso',
      color: '#95B040',
      image: <Fragment>
        <FullFlameIcon color={'#95B040'}></FullFlameIcon>
      </Fragment>
    },
    detail: [
      {
        points: {
          number: '8',
          pointsLabel: 'pts',
          currency: '/$'
        },
        description: '8 points earned per dollar spent'
      },
      {
        description: 'Your birthday reward: Regular Shake',
        imageName: 'birthday-reward.png'
      }
    ]

  },
  {
    tierPoints: {
      title: 'Scorcho',
      subtitle: 'Unlock at 250 level points',
      color: 'black',
      image: <Fragment>
        <FullFlameIcon color={'black'}></FullFlameIcon>
      </Fragment>
    },
    detail: [
      {
        points: {
          number: '10',
          pointsLabel: 'pts',
          currency: '/$'
        },
        description: '10 points earned per dollar spent'
      },
      {
        description: 'Your birthday reward: Regular Shake',
        imageName: 'birthday-reward.png'
      },
      {
        description: 'FREE 3 Layer Queso Nachos every 3 months',
        imageName: '3-Layer-Queso.png'
      }
    ]

  },
  {
    tierPoints: {
      title: 'Inferno',
      subtitle: 'Unlock at 1000 level points',
      color: '#DF8E35',
      image: <Fragment>
        <FullFlameIcon color={'#DF8E35'}></FullFlameIcon>
      </Fragment>
    },
    detail: [
      {
        points: {
          number: '11',
          pointsLabel: 'pts',
          currency: '/$'
        },
        description: '11 points earned per dollar spent'
      },
      {
        description: 'Your birthday reward: Any shake or dessert',
        imageName: 'birthday-reward.png'
      },
      {
        description: 'FREE Chips & Guac or Queso every 2 months',
        imageName: 'hero-Chips-and-Guac.png'
      }
    ]

  },
  {
    tierPoints: {
      title: 'Epic',
      subtitle: 'Unlock at 2000 level points',
      color: '#D6483B',
      image: <Fragment>
        <FullFlameIcon color={'#D6483B'}></FullFlameIcon>
      </Fragment>
    },
    detail: [
      {
        points: {
          number: '12',
          pointsLabel: 'pts',
          currency: '/$'
        },
        description: '12 points earned per dollar spent'
      },
      {
        description: 'Your birthday reward: Any shake or dessert',
        imageName: 'any-shake-or-dessert.png'
      },
      {
        description: 'FREE Epic Burrito every 3 months',
        imageName: 'free-epic-burrito.png'
      }
    ]

  }
]